class TrialApplication {
  constructor(
    id,
    parentName,
    email,
    studentName,
    studentAge,
    opinion,
    createdAt,
    updatedAt
  ) {
    this.id = id
    this.parentName = parentName
    this.email = email
    this.studentName = studentName
    this.studentAge = studentAge
    this.opinion = opinion
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }

  toObject() {
    return {
      id: this.id,
      data: {
        parentName: this.parentName,
        email: this.email,
        studentName: this.studentName,
        studentAge: this.studentAge,
        opinion: this.opinion,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      }
    }
  }
}

export { TrialApplication }